import React, { useEffect, useState } from 'react';
import { Card } from '../components/ui/card';
import { Progress } from '../components/ui/progress';
import api from '../api';

export default function Analytics() {
  const [summary, setSummary] = useState({ emails_sent:0, open_rate:0, reply_rate:0, bounce_rate:0 });
  const [campaigns, setCampaigns] = useState([]);

  useEffect(() => {
    api.get('/analytics/summary').then(r => setSummary(r.data)).catch(()=>{});
    api.get('/analytics/campaigns').then(r => setCampaigns(r.data)).catch(()=>{});
  }, []);

  return (
    <div className="p-8 max-w-7xl mx-auto">
      <h1 className="font-display text-3xl">Analytics</h1>
      <p className="text-zinc-500 mt-1">How your outreach is performing across all campaigns.</p>

      <div className="mt-6 grid grid-cols-2 lg:grid-cols-4 gap-4">
        {[
          { l: 'Emails sent', v: summary.emails_sent, sub: 'lifetime' },
          { l: 'Open rate', v: summary.emails_sent ? summary.open_rate + '%' : '—', sub: 'Industry avg 42%' },
          { l: 'Reply rate', v: summary.emails_sent ? summary.reply_rate + '%' : '—', sub: 'Higher is better' },
          { l: 'Bounce rate', v: summary.emails_sent ? summary.bounce_rate + '%' : '—', sub: 'Keep under 3%' },
        ].map(s => (
          <Card key={s.l} className="bg-[#111110] border-zinc-900 p-5">
            <div className="text-xs text-zinc-500">{s.l}</div>
            <div className="mt-2 font-display text-3xl gold-text">{s.v}</div>
            <div className="mt-1 text-xs text-zinc-500">{s.sub}</div>
          </Card>
        ))}
      </div>

      <Card className="mt-6 bg-[#111110] border-zinc-900">
        <div className="p-5 border-b border-zinc-900">
          <div className="font-display text-lg">Per-campaign performance</div>
          <div className="text-xs text-zinc-500 mt-1">Open, reply, and bounce rates side by side.</div>
        </div>
        <div className="divide-y divide-zinc-900">
          {campaigns.length === 0 && <div className="p-8 text-center text-zinc-500 text-sm">No campaigns yet.</div>}
          {campaigns.map(c => {
            const m = c.metrics || {};
            const sent = m.sent || 0;
            const openPct = sent ? Math.round(m.opens/sent*100) : 0;
            const replyPct = sent ? Math.round(m.replies/sent*100) : 0;
            const bouncePct = sent ? Math.round(m.bounces/sent*100) : 0;
            return (
              <div key={c.id} className="p-5">
                <div className="flex items-center justify-between mb-3">
                  <div>
                    <div className="text-zinc-100">{c.name}</div>
                    <div className="text-xs text-zinc-500">{sent} sent</div>
                  </div>
                </div>
                <div className="grid md:grid-cols-3 gap-4">
                  <div>
                    <div className="flex justify-between text-xs mb-1"><span className="text-zinc-500">Opens</span><span className="text-zinc-300">{openPct}%</span></div>
                    <Progress value={openPct} className="h-1.5 bg-zinc-900"/>
                  </div>
                  <div>
                    <div className="flex justify-between text-xs mb-1"><span className="text-zinc-500">Replies</span><span className="text-[#f5d67a]">{replyPct}%</span></div>
                    <Progress value={replyPct} className="h-1.5 bg-zinc-900"/>
                  </div>
                  <div>
                    <div className="flex justify-between text-xs mb-1"><span className="text-zinc-500">Bounces</span><span className="text-red-400">{bouncePct}%</span></div>
                    <Progress value={bouncePct} className="h-1.5 bg-zinc-900"/>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </Card>
    </div>
  );
}
